import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div>
      <div id="footer-part">
        <div class="footer-top pt-40 pb-70">
          <div class="container">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="footer-about mt-40">
                  <div class="logo">
                    <Link to="/">
                      <img src="images/logo-2.png" alt="Logo" />
                    </Link>
                  </div>
                  <p>
                    The books that help you most are those which make you think
                    that most. The hardest way of learning is that of easy
                    reading; but a great book that comes from a great thinker is
                    a ship of thought deep freighted with truth and beauty.
                  </p>
                  <ul class="mt-20">
                    <li>
                      <Link to="#" target="_blank">
                        <i class="fa fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        target="_blank"
                      >
                        <i class="fa fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link mt-40">
                  <div class="footer-title pb-25">
                    <h6>Sitemap</h6>
                  </div>
                  <ul>
                    <li>
                      <Link to="/">
                        <i class="fa fa-angle-right"></i>Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about">
                        <i class="fa fa-angle-right"></i>About us
                      </Link>
                    </li>
                    <li>
                      <Link to="/choosetemplates">
                        <i class="fa fa-angle-right"></i>Certificate
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/game">
                        <i class="fa fa-angle-right"></i>Game
                      </Link>
                    </li> */}
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>Event
                      </a>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <Link to="/gallery">
                        <i class="fa fa-angle-right"></i>Gallery
                      </Link>
                    </li>
                    <li>
                      <Link to="/analysis">
                        <i class="fa fa-angle-right"></i>Analysis
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i class="fa fa-angle-right"></i>Admin Login
                      </Link>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>Support
                      </a>
                    </li>
                    <li>
                      <Link to="/contact">
                        <i class="fa fa-angle-right"></i>Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="footer-link support mt-40">
                  <div class="footer-title pb-25">
                    <h6>Support</h6>
                  </div>
                  <ul>
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>FAQS
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>Privacy
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>Policy
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>Support
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-angle-right"></i>Documentation
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="footer-address mt-40">
                  <div class="footer-title pb-25">
                    <h6>Contact Us</h6>
                  </div>
                  <ul>
                    <li>
                      <div class="icon">
                        <i class="fa fa-home"></i>
                      </div>
                      <div class="cont">
                        <p>Rohtak (Haryana)</p>
                      </div>
                    </li>
                    <li>
                      <div class="icon">
                        <i class="fa fa-phone"></i>
                      </div>
                      <div class="cont">
                        <p>+91 0000000000</p>
                      </div>
                    </li>
                    <li>
                      <div class="icon">
                        <i class="fa fa-envelope-o"></i>
                      </div>
                      <div class="cont">
                        <p>samridhisofficial@gmail.com</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
